import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalContext } from '@notino/react-styleguide';

import { messages } from '../../messages';

import {
  ModalCloseButton,
  modalHeaderWrapperClass,
  modalHeaderWrapperNewDesignClass,
  ModalTitleWrapper,
} from './styled';

export const ModalHeader = ({
  isSuccessModal,
}: {
  isSuccessModal?: boolean;
}) => {
  const { hideModal } = ModalContext.useModalContext();

  const wrapperClassName = isSuccessModal
    ? modalHeaderWrapperClass
    : modalHeaderWrapperNewDesignClass;

  return (
    <div className={wrapperClassName}>
      {!isSuccessModal && (
        <ModalTitleWrapper>
          <FormattedMessage {...messages.reviewModalTitle} />
        </ModalTitleWrapper>
      )}

      <ModalCloseButton
        onClick={hideModal}
        tabIndex={0}
        aria-expanded="true"
        aria-keyshortcuts="Escape"
      />
    </div>
  );
};
